import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Switch, Form, Row, Col, Button, Input, Icon, Badge, Tag, message } from 'antd';

import Tip from '~/components/Tip';

var Services = function(props) {
    var getFieldDecorator = props.form.getFieldDecorator;
    var getFieldValue = props.form.getFieldValue;
    var data = props.data;
    var setPrepareData = props.setPrepareData;
    var tenantId = props.tenantId;

    var newCnaeState = useState('');
    var newCnae = newCnaeState[0];
    var setNewCnae = newCnaeState[1];

    var cnaesState = useState(data.cnaes ? data.cnaes.split(',') : []);
    var cnaes = cnaesState[0];
    var setCnaes = cnaesState[1];

    useEffect(function() {
        setPrepareData({cnaes: cnaes});
    }, [cnaes]);

    useEffect(function() {
        setPrepareData({allow_nf: getFieldValue('allow_nf') ? 1 : 0});
    }, [getFieldValue('allow_nf')]);

    var handleAddCnae = function() {
        if (newCnae) {
            setCnaes([].concat(cnaes, [newCnae]));
            setNewCnae('');
        }
    };

    var handleRemoveCnae = function(cnae) {
        setCnaes(cnaes.filter(function(item) { return item !== cnae; }));
    };

    var isNf = getFieldValue('allow_nf') !== undefined ? getFieldValue('allow_nf') : (data.allow_nf || false);
    var isExtrato = getFieldValue('extrato_bancario') !== undefined ? getFieldValue('extrato_bancario') : (data.extrato_bancario || false);

    return (
        <div>
            <div style={{
                borderRadius: 12,
                border: '1px solid ' + (isNf ? '#d6e4ff' : '#e8e8e8'),
                background: isNf ? '#fafcff' : '#fff',
                transition: 'all 0.2s',
                overflow: 'hidden',
            }}>
                {/* Header */}
                <div style={{
                    padding: '20px 24px',
                    display: 'flex', alignItems: 'center', gap: 16,
                    background: isNf ? '#f0f5ff' : '#fafafa',
                    borderBottom: isNf ? '1px solid #d6e4ff' : 'none',
                }}>
                    <div style={{
                        width: 44, height: 44, borderRadius: 10,
                        background: isNf ? '#1890ff14' : '#f0f0f0',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                    }}>
                        <Icon type="file-text" style={{ fontSize: 22, color: isNf ? '#1890ff' : '#8c8c8c' }} />
                    </div>
                    <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: 600, fontSize: 15, color: '#262626', marginBottom: 2 }}>
                            Emissão de NF-e <Tip>Se habilitado, o cliente poderá solicitar a emissão de NF-e através do painel do cliente. As solicitações serão listadas no módulo "Solicitações".</Tip>
                        </div>
                        <div style={{ fontSize: 13, color: '#8c8c8c' }}>O cliente optou por contratar/pagar o serviço de emissão de notas fiscais.</div>
                        {data.allow_nf_changed_at && (
                            <div style={{ fontSize: 12, color: '#bfbfbf', marginTop: 4 }}>
                                {data.allow_nf ? 'Habilitado' : 'Desabilitado'} por {data.allow_nf_changed_by_name || 'usuário'} em {new Date(data.allow_nf_changed_at).toLocaleDateString('pt-BR')}
                            </div>
                        )}
                    </div>
                    {getFieldDecorator('allow_nf', { valuePropName: 'checked', initialValue: !!data.allow_nf })(
                        <Switch checkedChildren="Sim" unCheckedChildren="Não" />
                    )}
                </div>

                {/* Expanded content */}
                {isNf && (
                    <div style={{ padding: '20px 24px' }}>
                        {/* Códigos de Serviço */}
                        <div style={{ marginBottom: 20 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
                                <Icon type="tags" style={{ fontSize: 15, color: '#722ed1' }} />
                                <span style={{ fontWeight: 600, fontSize: 13, color: '#434343' }}>
                                    Códigos de Serviço
                                </span>
                                <Tip>Adicione os códigos de serviço que o cliente poderá solicitar a emissão de NF-e.</Tip>
                                {cnaes.length > 0 && (
                                    <Badge count={cnaes.length} style={{ backgroundColor: '#52c41a', marginLeft: 4 }} />
                                )}
                            </div>

                            <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
                                <Input
                                    style={{ flex: 1, borderRadius: 6 }}
                                    value={newCnae}
                                    onChange={function(e) { setNewCnae(e.target.value); }}
                                    onPressEnter={handleAddCnae}
                                    placeholder="Adicionar código de serviço"
                                />
                                <Button type="primary" onClick={handleAddCnae} style={{ borderRadius: 6 }}>
                                    Adicionar
                                </Button>
                            </div>

                            {cnaes.length > 0 ? (
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                                    {cnaes.map(function(cnae) {
                                        return (
                                            <Tag
                                                key={cnae}
                                                closable
                                                onClose={function() { handleRemoveCnae(cnae); }}
                                                color="blue"
                                                style={{ fontSize: 13, padding: '4px 10px', borderRadius: 6 }}
                                            >
                                                {cnae}
                                            </Tag>
                                        );
                                    })}
                                </div>
                            ) : (
                                <div style={{
                                    textAlign: 'center', padding: '16px 0',
                                    color: '#bfbfbf', fontSize: 13,
                                    background: '#fafafa', borderRadius: 8,
                                    border: '1px dashed #e8e8e8',
                                }}>
                                    Nenhum código de serviço cadastrado
                                </div>
                            )}
                        </div>

                        {/* Link público */}
                        {data.public_nfe_token && (
                            <div style={{
                                padding: '14px 16px', borderRadius: 8,
                                background: '#f6f9fe', border: '1px solid #e8edf5',
                                display: 'flex', alignItems: 'flex-start', gap: 12,
                            }}>
                                <Icon type="link" style={{ fontSize: 15, color: '#1890ff', marginTop: 2 }} />
                                <div style={{ flex: 1 }}>
                                    <div style={{ fontWeight: 600, fontSize: 13, color: '#434343', marginBottom: 2 }}>Link público de solicitação</div>
                                    <div style={{ fontSize: 12, color: '#8c8c8c', marginBottom: 10 }}>
                                        Compartilhe este link com o cliente para que ele possa solicitar emissão de NF-e sem precisar fazer login.
                                    </div>
                                    <Button
                                        icon="copy"
                                        size="small"
                                        style={{ borderRadius: 6 }}
                                        onClick={function() {
                                            navigator.clipboard.writeText(
                                                process.env.REACT_APP_CUSTOMER_DOMAIN + '/solicitar-nfe/' + tenantId + '/' + data.public_nfe_token
                                            );
                                            message.success('Link NF-e copiado!');
                                        }}
                                    >
                                        Copiar link NF-e
                                    </Button>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>

            {/* Extrato Bancário no portal (CON-325) */}
            <div style={{
                marginTop: 16,
                borderRadius: 12,
                border: '1px solid ' + (isExtrato ? '#e6ccff' : '#e8e8e8'),
                background: isExtrato ? '#faf8fd' : '#fff',
                transition: 'all 0.2s',
                padding: '20px 24px',
                display: 'flex', alignItems: 'center', gap: 16,
            }}>
                <div style={{
                    width: 44, height: 44, borderRadius: 10,
                    background: isExtrato ? '#722ed114' : '#f0f0f0',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                }}>
                    <Icon type="bank" style={{ fontSize: 22, color: isExtrato ? '#722ed1' : '#8c8c8c' }} />
                </div>
                <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 600, fontSize: 15, color: '#262626', marginBottom: 2 }}>
                        Extrato Bancário no portal <Tip>Se habilitado, o cliente vê a aba "Extrato Bancário" no portal, envia os PDFs mês a mês e recebe o lembrete mensal por e-mail. A função precisa estar ligada em Configurações › Extrato Bancário.</Tip>
                    </div>
                    <div style={{ fontSize: 13, color: '#8c8c8c' }}>O cliente envia os extratos bancários e de aplicações pelo portal.</div>
                    {data.extrato_bancario_changed_at && (
                        <div style={{ fontSize: 12, color: '#bfbfbf', marginTop: 4 }}>
                            {data.extrato_bancario ? 'Habilitado' : 'Desabilitado'} por {data.extrato_bancario_changed_by_name || 'usuário'} em {new Date(data.extrato_bancario_changed_at).toLocaleDateString('pt-BR')}
                        </div>
                    )}
                </div>
                {getFieldDecorator('extrato_bancario', { valuePropName: 'checked', initialValue: !!data.extrato_bancario })(
                    <Switch checkedChildren="Sim" unCheckedChildren="Não" />
                )}
            </div>
        </div>
    );
};

var mapStateToProps = function(state) {
    return {
        tenantId: state.user.tenant.id,
    };
};

export default connect(mapStateToProps)(Services);
